"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _RawText = _interopRequireDefault(require("../Text/RawText"));

var _constants = require("./constants");

var _TooltipSt = require("./Tooltip.st.css");

var _excluded = ["onShow", "onHide", "size", "className", "placement", "exitDelay", "enterDelay", "moveArrowTo", "appendTo", "flip", "fixed", "maxWidth", "fluid", "moveBy", "disabled", "children", "zIndex", "textAlign", "content", "aria-describedby"];

var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-style-react/dist/cjs/Tooltip/Tooltip.tsx",
    _this = void 0;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Tooltip = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var onShow = _ref.onShow,
      onHide = _ref.onHide,
      size = _ref.size,
      className = _ref.className,
      placement = _ref.placement,
      exitDelay = _ref.exitDelay,
      enterDelay = _ref.enterDelay,
      moveArrowTo = _ref.moveArrowTo,
      appendTo = _ref.appendTo,
      flip = _ref.flip,
      fixed = _ref.fixed,
      maxWidth = _ref.maxWidth,
      fluid = _ref.fluid,
      moveBy = _ref.moveBy,
      disabled = _ref.disabled,
      children = _ref.children,
      zIndex = _ref.zIndex,
      textAlign = _ref.textAlign,
      content = _ref.content,
      ariaDescribedBy = _ref['aria-describedby'],
      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      shown = _useState[0],
      setShown = _useState[1];

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      open: open,
      close: close
    };
  });
  var open = (0, _react.useCallback)(function () {
    setShown(true);
    onShow == null ? void 0 : onShow();
  }, [onShow]);
  var close = (0, _react.useCallback)(function () {
    setShown(false);
    onHide == null ? void 0 : onHide();
  }, [onHide]);
  var isDisabled = (0, _react.useMemo)(function () {
    var _children$props;

    return disabled === undefined ? // @ts-expect-error
    (children == null ? void 0 : children.props) && (children == null ? void 0 : (_children$props = children.props) == null ? void 0 : _children$props.disabled) : disabled;
  }, [children, disabled]);
  var onFocus = (0, _react.useCallback)(function (_event, handlers) {
    var focusableHOC = handlers && handlers.focus;
    open();
    return focusableHOC ? handlers.focus() : null;
  }, [open]);
  var onBlur = (0, _react.useCallback)(function (_event, handlers) {
    var focusableHOC = handlers && handlers.blur;
    close();
    return focusableHOC ? handlers.blur() : null;
  }, [close]);
  var triggerElement = (0, _react.useMemo)(function () {
    if (typeof children === 'string' || !children) {
      return children;
    }

    return /*#__PURE__*/_react["default"].cloneElement(children, {
      onFocus: isDisabled ? undefined : onFocus,
      onBlur: isDisabled ? undefined : onBlur,
      'aria-describedby': ariaDescribedBy
    });
  }, [children, isDisabled, onFocus, onBlur, ariaDescribedBy]);
  var contentElement = (0, _react.useMemo)(function () {
    var textSize = size === 'small' ? 'tiny' : 'small';
    var textWeight = size === 'small' ? 'normal' : 'thin';
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        textAlign: textAlign
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101,
        columnNumber: 9
      }
    }, typeof content === 'string' ?
    /*#__PURE__*/
    // @ts-ignore
    _react["default"].createElement(_RawText["default"], {
      dataHook: _constants.dataHooks.tooltipText,
      size: textSize,
      weight: textWeight,
      light: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104,
        columnNumber: 13
      }
    }, content) : content);
  }, [content, textAlign, size]);
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], (0, _extends2["default"])({
    role: "tooltip",
    showArrow: size !== 'small',
    className: (0, _TooltipSt.st)(_TooltipSt.classes.root, {
      size: size
    }, className),
    placement: placement,
    shown: isDisabled ? false : shown,
    onMouseEnter: isDisabled ? undefined : open,
    onMouseLeave: close,
    onClickOutside: close,
    "data-size": size,
    hideDelay: exitDelay,
    showDelay: enterDelay,
    moveBy: moveBy,
    moveArrowTo: moveArrowTo,
    appendTo: appendTo,
    id: ariaDescribedBy,
    flip: flip,
    fixed: fixed,
    maxWidth: maxWidth,
    fluid: fluid,
    disableClickOutsideWhenClosed: true,
    zIndex: zIndex
  }, rest, {
    theme: "dark",
    timeout: _constants.TIMEOUT,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 7
    }
  }), /*#__PURE__*/_react["default"].createElement(_Popover["default"].Element, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 9
    }
  }, triggerElement), /*#__PURE__*/_react["default"].createElement(_Popover["default"].Content, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 147,
      columnNumber: 9
    }
  }, contentElement));
});
Tooltip.defaultProps = {
  placement: 'top',
  appendTo: 'window',
  onShow: function onShow() {
    return {};
  },
  onHide: function onHide() {
    return {};
  },
  enterDelay: 0,
  exitDelay: 0,
  maxWidth: 204,
  flip: true,
  fixed: false,
  textAlign: 'start',
  size: 'medium',
  zIndex: 6000,
  content: ''
};
Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = {
  dataHook: _propTypes["default"].string,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  content: _propTypes["default"].node,
  textAlign: _propTypes["default"].oneOf(['start', 'center']),
  enterDelay: _propTypes["default"].number,
  exitDelay: _propTypes["default"].number,
  // @ts-expect-error
  moveBy: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),
  moveArrowTo: _propTypes["default"].number,
  // @ts-expect-error
  appendTo: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['window', 'scrollParent', 'viewport', 'parent']), _propTypes["default"].element, _propTypes["default"].func]),
  flip: _propTypes["default"].bool,
  fixed: _propTypes["default"].bool,
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  onShow: _propTypes["default"].func,
  onHide: _propTypes["default"].func,
  placement: _propTypes["default"].oneOf(['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']),
  disabled: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(['small', 'medium']),
  'aria-describedby': _propTypes["default"].string,
  zIndex: _propTypes["default"].number,
  fluid: _propTypes["default"].bool
};
var _default = Tooltip;
exports["default"] = _default;
//# sourceMappingURL=Tooltip.js.map